import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=3518fc41&scoped=true&"
import script from "./Vulnerability.vue?vue&type=script&lang=js&"
export * from "./Vulnerability.vue?vue&type=script&lang=js&"
import style0 from "./Vulnerability.vue?vue&type=style&index=0&id=3518fc41&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518fc41",
  null
  
)

export default component.exports